import React from 'react';
import { Box } from '@mui/material';
import useChooseShopStyles from '../../styles/perfectMatch/chooseShop';

import logo from '../../assets/images/perfect_match/logo.jpg';
import bottlesImage from '../../assets/images/perfect_match/p1.jpg';
import promoalcool from '../../assets/images/promo-despre-alcool.png';

export type ShopType = 'kaufland' | 'carrefour' | 'mega-image';

interface ChooseShopProps {
    onShopSelected: (shop: ShopType) => void;
}

const ChooseShop: React.FC<ChooseShopProps> = ({ onShopSelected }) => {
    const classes = useChooseShopStyles();

    return (
        <Box className={classes.container}>
            {/* Left Side - Full Height Image */}
            <Box className={classes.imageSection}>
                <img
                    src={bottlesImage}
                    alt="Kozel Premium and Dark bottles"
                    className={classes.bottlesImage}
                />
            </Box>

            {/* Right Side - Logo, Title and Buttons */}
            <Box className={classes.contentSection}>
                <img
                    src={logo}
                    alt="Kozel Perfect Match"
                    className={classes.logoImage}
                />

                <h2 className={classes.title}>Alege magazin:</h2>

                <Box className={classes.buttonsContainer}>
                    <button
                        onClick={() => onShopSelected('kaufland')}
                        className={classes.shopButton}
                    >
                        KAUFLAND
                    </button>

                    <button
                        onClick={() => onShopSelected('carrefour')}
                        className={classes.shopButton}
                    >
                        CARREFOUR
                    </button>

                    {/* <button 
                        onClick={() => onShopSelected('mega-image')}
                        className={classes.shopButton}
                    >
                        MEGA IMAGE
                    </button> */}
                    <img
                        src={promoalcool}
                        alt="Promo Alcool"
                        className={classes.logoImage}
                        style={{ marginTop: '2rem' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default ChooseShop;